import React, { Component } from "react";

import Dropzone from 'react-dropzone'

import asWizard from "./Wizard";

import VeranstaltungServiceInstance from "../services/VeranstaltungService";

import AnmeldungService from "../services/AnmeldungService";


import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { ValidatableInput, ValidatableSelect, valueIsNotEmpty, isValidJahrgang, valueIsNotEmptyAndLength, isValidEMail, validateData } from "./Validation"
import AnmeldungTrainerSubmit from "./AnmeldungTrainerSubmit";
import InputChangeHandler from "./InputChangeHandler";

class AnmeldungTrainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isModalOpen: false
            , allgemeinData: {
                inputMail: { value: "", validator: isValidEMail, invalidText: "Bitte geben Sie eine korrekte E-Mail-Adresse ein. An diese wird später die Anmeldebestätigung versendet." }
                , inputVerein: { value: "", validator: valueIsNotEmptyAndLength }
                , inputVerband: { value: "" }
            }, allgemeinWasValidated: false
            , indexInArray: null
            , currentSportlerData: {
                inputVorname: { value: "", validator: valueIsNotEmptyAndLength, invalidText: "Vorname muss eingegeben werden und darf maximal 40 Zeichen lang sein." }
                , inputNachname: { value: "", validator: valueIsNotEmptyAndLength, invalidText: "Nachname muss eingegeben werden und darf maximal 40 Zeichen lang sein." }
                , inputJahrgang: { value: "", validator: isValidJahrgang, invalidText: "Jahrgang muss 4-stellig eingegeben werden (z.B. 1965)" }
                , inputGeschlecht: { value: "M", label: "männlich", validator: valueIsNotEmpty }
                , inputWettbewerb: { value: "", label: "", validator: valueIsNotEmpty, invalidText: "Mindestens ein Wettbewerb muss ausgewählt werden." }
                , inputStartpass: { value: "" }
            }, sportlerWasValidated: false
            , sportler: []
            , isDatenschutzAccepted: false
            , event: null
            , dropzoneText: "Anmeldungen hier ablegen oder klick um Datei auszuwählen"
        };

        this.allgemeinDataChangeHandler = new InputChangeHandler("allgemeinData", this);
        this.currentSportlerDataChangeHandler = new InputChangeHandler("currentSportlerData", this);
    }

    componentDidMount() {
        const eventId = Number(this.props.match.params.id);
        VeranstaltungServiceInstance.getById(eventId).then(event => {

            /* Wettbewerb vorauswählen, falls nur einer vorhanden ist  */
            const wettbewerbe = event.wettbewerbe;
            let wettbewerbValue = "";
            let wettbewerbLabel = "";

            if (wettbewerbe.length === 1) {
                wettbewerbValue = wettbewerbe[0].id;
                wettbewerbLabel = wettbewerbe[0].bezeichnung;
            }

            const newCurrentSportlerData = { ...this.state.currentSportlerData };
            newCurrentSportlerData.inputWettbewerb.value = "" + wettbewerbValue;
            newCurrentSportlerData.inputWettbewerb.label = wettbewerbLabel;
            /***********************************************************/

            this.setState({ event: event, currentSportlerData: newCurrentSportlerData });
        });
    }

    onSubmitAllgemeineDaten = (e) => {
        e.preventDefault();
        if (validateData(this.state.allgemeinData)) {
            this.props.onNext(e);
        } else {
            this.setState({ allgemeinWasValidated: true });
        }
    }

    onSubmitSportlerDaten = (e) => {
        e.preventDefault();
        this.props.onNext(e);
    }

    onToggleModal = () => {
        this.setState(prevState => ({
            isModalOpen: !prevState.isModalOpen
            , indexInArray: null
        }));
    }

    onAddSportler = (e) => {
        e.preventDefault();
        if (validateData(this.state.currentSportlerData)) {
            const sportler = {
                vorname: this.state.currentSportlerData.inputVorname.value
                , nachname: this.state.currentSportlerData.inputNachname.value
                , jahrgang: this.state.currentSportlerData.inputJahrgang.value
                , geschlecht: { value: this.state.currentSportlerData.inputGeschlecht.value, label: this.state.currentSportlerData.inputGeschlecht.label }
                , wettbewerb: { value: this.state.currentSportlerData.inputWettbewerb.value, label: this.state.currentSportlerData.inputWettbewerb.label }
                , startpass: this.state.currentSportlerData.inputStartpass.value
            };
            console.log("add sportler");
            this.setState(prevState => {
                // Sportler entfernen, der editiert wurde
                //const sportlerList = prevState.sportler.filter((s, idx) => idx !== prevState.indexInArray);
                const sportlerList = prevState.sportler;
                const idx = prevState.indexInArray;
                let newSportlerList;

                if (prevState.indexInArray !== null) {
                    newSportlerList = [...sportlerList.slice(0, idx), sportler, ...sportlerList.slice(idx + 1)];
                } else {
                    newSportlerList = [...sportlerList, sportler];
                }

                return {
                    sportler: newSportlerList
                    , isModalOpen: false
                    , sportlerWasValidated: false
                    , indexInArray: null
                    , currentSportlerData: {
                        ...prevState.currentSportlerData
                        , inputVorname: { ...prevState.currentSportlerData.inputVorname, value: "" }
                        , inputNachname: { ...prevState.currentSportlerData.inputNachname, value: "" }
                        , inputJahrgang: { ...prevState.currentSportlerData.inputJahrgang, value: "" }
                        , inputStartpass: { ...prevState.currentSportlerData.inputStartpass, value: "" }
                    }
                };
            });
        } else {
            this.setState({ sportlerWasValidated: true });
        }
    }

    deleteSportler = (idx, e) => {
        e.preventDefault();
        console.log("delete ", idx);
        const newSportler = this.state.sportler.filter((el, i) => i !== idx);
        this.setState(prevState => ({
            sportler: newSportler
        }));
    }

    editSportler = (idx, e) => {
        e.preventDefault();
        console.log("edit ", idx);
        this.setState(prevState => {
            const sportlerToEdit = prevState.sportler[idx];
            console.log("Sportler: ", sportlerToEdit);

            return {
                indexInArray: idx
                , currentSportlerData: {
                    inputVorname: { ...prevState.currentSportlerData.inputVorname, value: sportlerToEdit.vorname }
                    , inputNachname: { ...prevState.currentSportlerData.inputNachname, value: sportlerToEdit.nachname }
                    , inputJahrgang: { ...prevState.currentSportlerData.inputJahrgang, value: sportlerToEdit.jahrgang }
                    , inputGeschlecht: { ...prevState.currentSportlerData.inputGeschlecht, value: sportlerToEdit.geschlecht.value, label: sportlerToEdit.geschlecht.label }
                    , inputWettbewerb: { ...prevState.currentSportlerData.inputWettbewerb, value: sportlerToEdit.wettbewerb.value, label: sportlerToEdit.wettbewerb.label }
                    , inputStartpass: { ...prevState.currentSportlerData.inputStartpass, value: sportlerToEdit.startpass }
                }
                , isModalOpen: true
            };
        });
    }

    onDropExcel = (acceptedFiles, rejectedFiles) => {
        console.log(acceptedFiles);
        if (rejectedFiles.length > 0) {
            this.setState({ dropzoneText: "Nicht unterstützte Datei - Datei muss im korrekten Format vorliegen" });
        } else {
            AnmeldungService.excel2Anmeldungen(acceptedFiles[0]).then(res => {
                
                let wettbewerb = { value: "", label: "" };
                console.log("Ev: ", this.state.event);
                if (this.state.event && this.state.event.wettbewerbe.length === 1) {
                    const einzigerWettbewerb = this.state.event.wettbewerbe[0];
                    wettbewerb = { value: "" + einzigerWettbewerb.id, label: einzigerWettbewerb.bezeichnung };
                }

                let anmeldungen = res.data.anmeldungen;
                const sportler = anmeldungen.map(a => ({
                    vorname: a.vorname,
                    nachname: a.nachname,
                    jahrgang: a.jahrgang,
                    geschlecht: { value: a.geschlecht, label: (a.geschlecht === "M" ? "männlich" : "weiblich") },
                    wettbewerb: wettbewerb,
                    startpass: a.startpass
                }));

                this.setState((prevState) => {
                    return {
                        sportler: [...prevState.sportler, ...sportler]
                    };
                })
            });
        }
        // Do something with files
    }


    render() {
        const mitStartpass = this.state.event ? this.state.event.sollStartpassErfasstWerden : false;

        let Formular;
        let wizardStepLabel;
        switch (this.props.step) {
            case 0:
                Formular = <FormularAllgemeineDaten onNext={this.onSubmitAllgemeineDaten} formData={this.state.allgemeinData}
                    changeListener={this.allgemeinDataChangeHandler.onChange} wasValidated={this.state.allgemeinWasValidated} />
                wizardStepLabel = "Allgemeine Daten";
                break;
            case 1:
                Formular = <FormularSportlerErfassen onNext={this.onSubmitSportlerDaten} onToggleModal={this.onToggleModal}
                    isModalOpen={this.state.isModalOpen} onAddSportler={this.onAddSportler} formData={this.state.currentSportlerData}
                    changeListener={this.currentSportlerDataChangeHandler.onChange} wasValidated={this.state.sportlerWasValidated} sportler={this.state.sportler}
                    deleteSportler={this.deleteSportler} editSportler={this.editSportler} isNewSportler={this.state.indexInArray === null}
                    wettbewerbe={this.state.event ? this.state.event.wettbewerbe : []} mitStartpass={mitStartpass} onDrop={this.onDropExcel}
                    dropzoneText={this.state.dropzoneText}
                />
                wizardStepLabel = "Sportler erfassen";
                break;
            case 2:
                Formular = <AnmeldungTrainerSubmit allgemeinData={this.state.allgemeinData} sportlerList={this.state.sportler}
                    eventId={this.props.match.params.id} onSuccess={() => { this.props.history.push("/thankyou"); }} mitStartpass={mitStartpass} />
                wizardStepLabel = "Daten überprüfen";
                break;
        }

        const event = this.state.event || {};

        return (
            <div className="jh-content">
                <div className="row">
                    <div className="col-md-12">
                        <h1>{event.name}</h1>
                        <h5 className="jh-subheader">Veranstalter: {event.veranstalter} - Datum: {event.datum}</h5>
                    </div>
                </div>

                <h2><span className="jh-anmeldung-badge">{wizardStepLabel} ({this.props.step + 1}/3)</span></h2>

                <div className="row">
                    <div className="col-md-12">
                        {Formular}
                    </div>
                </div>

            </div>
        );
    }

}

const FormularAllgemeineDaten = ({ onNext, formData, changeListener, wasValidated }) => {
    return (
        <form className="jh-content-form">

            <div className="form-row">
                <div className="form-group col-md-12">
                    <label htmlFor="inputMail">E-Mail-Adresse</label>
                    <ValidatableInput type="email" name="inputMail" field={formData.inputMail} changeListener={changeListener} showValidationResult={wasValidated} />
                </div>
            </div>

            <div className="form-row">
                <div className="form-group col-md-8">
                    <label htmlFor="inputVerein">Verein/Team</label>
                    <ValidatableInput name="inputVerein" field={formData.inputVerein} changeListener={changeListener} showValidationResult={wasValidated} />
                </div>
                <div className="form-group col-md-4">
                    <label htmlFor="inputVerband">Verband</label>
                    <ValidatableInput name="inputVerband" field={formData.inputVerband} changeListener={changeListener} showValidationResult={wasValidated} />
                </div>
            </div>

            <div className="form-row">
                <div className="form-group offset-sm-9 col-sm-3 offset-md-10 col-md-2 ">
                    <button type="submit" className="btn btn-primary btn-block jh-btn" onClick={onNext}>Weiter</button>
                </div>
            </div>

        </form>
    );
}

const FormularSportlerErfassen = ({ onNext, onToggleModal, isModalOpen, onAddSportler, formData, changeListener, wasValidated, sportler, deleteSportler, editSportler, isNewSportler, wettbewerbe, mitStartpass, onDrop, dropzoneText }) => {

    let habenAlleSportlerEinenWettbewerb = true;
    sportler.some(s => {
        if (s.wettbewerb.value === "") {
            habenAlleSportlerEinenWettbewerb = false;
            return true;
        }
    });

    return (
        <React.Fragment>


            <Modal isOpen={isModalOpen} toggle={onToggleModal}>
                <ModalHeader toggle={onToggleModal}>Sportler hinzufügen</ModalHeader>
                <ModalBody>
                    <form className="jh-content-form" onSubmit={onAddSportler} noValidate>
                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputVorname">Vorname</label>
                                <ValidatableInput name="inputVorname" field={formData.inputVorname} changeListener={changeListener} showValidationResult={wasValidated} />
                            </div>
                            <div className="form-group col-md-6">
                                <label htmlFor="inputNachname">Nachname</label>
                                <ValidatableInput name="inputNachname" field={formData.inputNachname} changeListener={changeListener} showValidationResult={wasValidated} />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="inputJahrgang">Jahrgang</label>
                                <ValidatableInput type="number" name="inputJahrgang" field={formData.inputJahrgang} changeListener={changeListener} showValidationResult={wasValidated} />
                            </div>
                            <div className="form-group col-md-6">
                                <label htmlFor="inputGeschlecht">Geschlecht</label>
                                <ValidatableSelect options={[{ id: "M", bezeichnung: "männlich" }, { id: "W", bezeichnung: "weiblich" }]} name="inputGeschlecht" field={formData.inputGeschlecht} changeListener={changeListener} showValidationResult={wasValidated} />
                            </div>
                        </div>

                        {mitStartpass && <div className="form-row">
                            <div className="form-group col-md-12">
                                <label htmlFor="inputStartpass">Startpass</label>
                                <ValidatableInput name="inputStartpass" field={formData.inputStartpass} changeListener={changeListener} showValidationResult={wasValidated} />
                            </div>
                        </div>}

                        <div className="form-row">
                            <div className="form-group col-md-12">
                                <label htmlFor="inputWettbewerb">Wettbewerb</label>
                                <ValidatableSelect options={wettbewerbe} name="inputWettbewerb" field={formData.inputWettbewerb} changeListener={changeListener} showValidationResult={wasValidated} />
                            </div>
                        </div>
                    </form>

                </ModalBody>
                <ModalFooter>
                    <Button color="danger" className="jh-btn" onClick={onToggleModal}>Abbrechen</Button>{' '}
                    <Button color="primary" className="jh-btn" onClick={onAddSportler}>{isNewSportler ? "Hinzufügen" : "Ändern"}</Button>
                </ModalFooter>
            </Modal>

            <div className="jh-content-form">

                <div className="d-none d-md-block">
                    <ul className="list-group" hidden={sportler.length === 0}>
                        <li className="list-group-item jh-list-group-header ">
                            <div className="row">
                                <div className="col-md-5">Sportler</div>
                                <div className="col-md-3">Wettbewerb</div>
                                <div className="col-md-2">{mitStartpass && "Startpass"}</div>
                                <div className="col-md-2 text-right"></div>
                            </div>
                        </li>
                        {sportler.map((s, idx) => {
                            return (<li className="list-group-item" key={idx}>
                                <div className="row">
                                    <div className="col-md-5" style={{ lineHeight: 1.2 }}>{s.vorname} {s.nachname} ({s.geschlecht.label})<br /><span className="jh-subline">Jahrgang: {s.jahrgang}</span></div>
                                    <div className="col-md-3">{s.wettbewerb.label}</div>
                                    <div className="col-md-2">{mitStartpass && s.startpass}</div>
                                    <div className="col-md-2 text-right"><a href="#" className="jh-primary" onClick={(e) => editSportler(idx, e)} data-toggle="tooltip" title="Bearbeiten"><i className="fa fa-edit"></i></a> <a href="#" className="jh-primary" onClick={(e) => deleteSportler(idx, e)} data-toggle="tooltip" data-placement="top" title="Löschen"><i className="fa fa-trash"></i></a></div>
                                </div>
                            </li>);
                        })}
                    </ul>
                </div>

                <ul className="list-group d-md-none" hidden={sportler.length === 0}>
                    {sportler.map((s, idx) => {
                        return (<li className="list-group-item" key={idx}>
                            <div className="row">
                                <div className="col-sm-12"><span>{s.vorname} {s.nachname} ({s.geschlecht.label})</span> - {s.wettbewerb.label}</div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 jh-subline">Jahrgang: {s.jahrgang}</div>
                            </div>
                            <div className="row" hidden={!mitStartpass}>
                                <div className="col-sm-12 jh-subline">{mitStartpass && "Startpass: " + s.startpass}</div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 text-right"><a href="#" className="jh-primary" onClick={(e) => editSportler(idx, e)} data-toggle="tooltip" title="Bearbeiten"><i className="fa fa-edit"></i></a> <a href="#" className="jh-primary" onClick={(e) => deleteSportler(idx, e)} data-toggle="tooltip" data-placement="top" title="Löschen"><i className="fa fa-trash"></i></a></div>
                            </div>
                        </li>);
                    })}
                </ul>


                <div className="form-row" hidden={sportler.length > 0}>
                    <div className="col-md-12">
                        <p style={{ fontWeight: 400, fontSize: "1em" }}>Es muss mindestens ein Sportler hinzugefügt werden, bevor die Anmeldung gespeichert werden kann. Außerdem besteht die Möglichkeit Sportler per Excel-Datei anzumelden. Eine Beispiel-Datei mit dem korrekten Format kann <a href="/downloads/startbereit_beispiel.xlsx" download="startbereit_beispiel.xlsx">hier</a> heruntergeladen werden. Jeder Sportler muss einem Wettbewerb zugeordnet werden, bevor die Anmeldung abgeschlossen werden kann.</p>
                    </div>
                </div>

                <div className="form-row" style={{ marginTop: "20px" }}>
                    <div className="form-group col-sm-12 col-md-6 col-lg-7">
                        <Dropzone onDrop={onDrop} accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                            {({ getRootProps, getInputProps, isDragActive }) => {
                                return (
                                    <div
                                        {...getRootProps()}
                                        className={"jh-dropzone" + (isDragActive ? " jh-dropzone-active" : "")}
                                    >
                                        <input {...getInputProps()} />
                                        {
                                            isDragActive ?
                                                <p>Anmeldungen hier ablegen...</p> :
                                                <p>{dropzoneText}</p>
                                        }
                                    </div>
                                )
                            }}
                        </Dropzone>
                    </div>
                    <div className="form-group col-sm-12 col-md-4 col-lg-3">
                        <Button color="primary" onClick={onToggleModal} style={{ marginRight: "10px" }} className="btn-block jh-btn">Sportler hinzufügen</Button>
                    </div>
                    <div className="form-group col-sm-12 col-md-2">
                        <Button color="primary" onClick={onNext} disabled={sportler.length === 0 || !habenAlleSportlerEinenWettbewerb} className="btn-block jh-btn">Weiter</Button>
                    </div>
                </div>
            </div>

        </React.Fragment>
    );
}

export default asWizard(AnmeldungTrainer);


// WEBPACK FOOTER //
// ./src/components/AnmeldungTrainer.js